import React from 'react';
import PropTypes from 'prop-types';
import Button from '@pattern-library/buttons';
import { SEARCH_KEY } from './DataGridFilters';
import { XBoldIcon } from '@pattern-library/icon';
const propTypes = {
  activeFilters: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.any
  })).isRequired,
  onClearFilter: PropTypes.func.isRequired,
  onClearAllFilters: PropTypes.func.isRequired
};
function DataGridFilterTags(_ref) {
  let {
    activeFilters,
    onClearFilter,
    onClearAllFilters
  } = _ref;
  let searchOnly = false;
  const filterTags = activeFilters.reduce((tags, filter) => {
    if (Array.isArray(filter.value)) {
      return tags.concat(filter.value.map(value => ({
        key: filter.key,
        tagLabel: filter.checkboxLabels?.[value] ? filter.checkboxLabels[value].label : value,
        value: value
      })));
    }
    const tagLabel = filter.label || filter.value;
    if (filter.key === SEARCH_KEY && activeFilters.length === 1) searchOnly = true;

    // do not show the search key in list
    if (filter.key !== SEARCH_KEY) {
      tags.push({
        key: filter.key,
        tagLabel,
        value: filter.value
      });
    }
    return tags;
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !searchOnly ? /*#__PURE__*/React.createElement("div", {
    className: "asc-grid-filter-tags"
  }, /*#__PURE__*/React.createElement("p", {
    id: "filter-desc",
    className: "asc-grid-filter-tags-label asc-hidden"
  }, "Filtered by:"), /*#__PURE__*/React.createElement("ul", {
    className: "asc-grid-filter-tags-list",
    "aria-describedby": "filter-desc"
  }, filterTags.map(_ref2 => {
    let {
      key,
      tagLabel,
      value
    } = _ref2;
    return /*#__PURE__*/React.createElement("li", {
      key: `${key}-${tagLabel}`
    }, /*#__PURE__*/React.createElement(Button, {
      className: "asc-btn--tertiary asc-btn--small",
      type: "button",
      text: /*#__PURE__*/React.createElement(React.Fragment, null, tagLabel, /*#__PURE__*/React.createElement(XBoldIcon, {
        color: "current",
        size: "xxs",
        customSize: "10px"
      })),
      customAttrs: {
        'aria-label': `Clear filter ${tagLabel}`
      },
      clickHandler: () => onClearFilter(key, value)
    }));
  })), /*#__PURE__*/React.createElement(Button, {
    className: "asc-btn asc-btn--small asc-btn--link asc-grid-filter-tags-clear-btn",
    type: "button",
    text: "Clear All",
    customAttrs: {
      'aria-label': 'Clear all filters'
    },
    clickHandler: onClearAllFilters
  })) : '');
}
DataGridFilterTags.propTypes = propTypes;
export default DataGridFilterTags;